import { makeAutoObservable } from "mobx";

interface IYTPlayer {
    playerId: string,
    player: YT.Player
}

class YTVideoPlayListStore {
    private _playList: IYTPlayer[] = [];

    constructor(videoList: IYTPlayer[] = []) {
        this._playList = videoList;
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public appendToPlayList(playerId: string, player: YT.Player) {
        this._playList.push({
            playerId,
            player
        });
    }

    public stopAllPlayersVideos() {
        this._playList.forEach(p => p.player.stopVideo());
    }
}

export default YTVideoPlayListStore;
